import { toTrimmedNonEmptyString } from '@/lib/utils/type-guards';

export function readSystemEnvString(key: string, fallback: string | null = null): string | null {
  try {
    const nodeProcess = (globalThis as { process?: { env?: Record<string, unknown> } }).process;
    const raw = nodeProcess?.env ? nodeProcess.env[key] : undefined;
    const value = toTrimmedNonEmptyString(raw);
    if (value) {
      return value;
    }
  } catch {
    // Ignore environment access errors (e.g., sandboxed runtimes)
  }
  return fallback;
}
